import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { authService } from '@/services/api'
import { useAuthStore } from '@/stores'
import type { VerificationStatus } from './EmailVerificationForm.static'

export function useEmailVerificationForm() {
  const { t } = useTranslation('auth')
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const [status, setStatus] = useState<VerificationStatus>(() => (token ? 'verifying' : 'error'))
  const [errorMessage, setErrorMessage] = useState(() =>
    token ? '' : t('verificationFailedMessage')
  )
  const hasVerified = useRef(false)

  useEffect(() => {
    if (hasVerified.current || !token) return

    hasVerified.current = true

    const verifyEmail = async () => {
      try {
        await authService.verifyEmail({ token })
        setStatus('success')
        // Update user in store
        const currentUser = useAuthStore.getState().user
        if (currentUser) {
          useAuthStore.getState().setUser({ ...currentUser, emailVerified: true })
        }
      } catch {
        setStatus('error')
        setErrorMessage(t('errors.verificationFailed'))
      }
    }

    verifyEmail()
  }, [token, t])

  return {
    t,
    status,
    errorMessage,
  }
}
